import dataFormat from './common/dataFormat';

/**
 * KLineEChartsFormatter类定义
 */
class KLineEChartsFormatter {
    /**
     * KLineEChartsFormatter类构造函数
     */
    constructor() {
        this.chartOption = {};
        this.tooltipObj = {};
    }

    /**
     * 记录包含数据和完整选项的图表选项
     * @param {Object} option echarts图表选项
     */
    setChartOption(option = {}) {
        this.chartOption = option;
    }

    /**
     * 格式化axisPointer方法
     * @param {Object} param echarts对象传递的参数
     * @returns {String} 返回格式化后的内容
     */
    axisPointerFormatter(param) {
        let value = Number(param.value);
        // 存在在一个grid里没有series的情况（比如：没有MACD指标），所以不能通过是否传递了seriesData来判断是x轴
        let formatValue = dataFormat.datetimeFormatLogic(value);
        if (formatValue) {
            return formatValue;
        }
        return dataFormat.numberFormatLogic(value);
    }

    /**
     * 获取axis格式化函数
     * @param {String} type 日期类型
     * @param {String} axisType 轴类型（默认：xAxis）
     * @returns {String} 返回格式化函数
     */
    getAxisFormatter(type, axisType) {
        return param => {
            // xAxis里传递的是值
            let value = Number(param);
            // y轴格式化(对于axisPointer的formatter方法x和y轴都会调用，但在方法里拿不到轴类型，所以靠外层传递的参数来判断)
            if (axisType === 'yAxis') {
                return dataFormat.numberFormatLogic(value, { more: { decimal: 0 } });
            }
            return dataFormat.datetimeFormatLogic(value, type);
        };
    }

    /**
     * 格式化成交量Y轴方法
     * @param {Number} value 成交量
     * @returns {String} 返回格式化后的值
     */
    volumeYAxisFormatter(value) {
        return dataFormat.volumeFormatLogic(value);
    }

    /**
     * 获取tooltip格式化函数
     * （因为axisPoint的link使三个图联动，但导致tooltip只能是一个，也就是说grid里配置的tooltip不起作用，
     * 所以将每块图表的tooltip拉高，界面看上去似乎是三块tooltip）
     * @param {Object} availableHeight echarts容器的高度
     * @param {Array<Object>} grids echarts布局选项
     * @returns {String} 返回tooltip格式化函数
     */
    getTooltipFormatter(availableHeight, grids) {
        return params => {
            // 有几个grid就生成几组seriesGroup
            let gridGroups = grids.map(() => {
                return [];
            });
            params.forEach(param => {
                let series = this.chartOption.series[param.seriesIndex];
                if (series.tooltip && series.tooltip.show === false) {
                    return;
                }
                gridGroups[param.axisIndex].push({
                    ...param,
                    option: series
                });
            });
            this.tooltipObj = {
                availableHeight,
                grids,
                gridGroups
            };
        };
    }
}

export default KLineEChartsFormatter;



// WEBPACK FOOTER //
// ./src/controller/KLineEChartsFormatter.js